/**
 * @generated SignedSource<<f2ed2612b7c7486e85716154de12a390>>
 * @relayHash b4a27f32364a9517087478ad23021f3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b5ea67d03d9e3f58ea9eb74be6abf19d7c9c183f8d844434f6956de6610b0bb

import type { ConcreteRequest } from 'relay-runtime';
export type fetchIssueAttachmentsSmartlinkDataQuery$variables = {
  cloudId: string;
  first: number;
  issueKey: string;
};
export type fetchIssueAttachmentsSmartlinkDataQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly getUnhydratedConsolidatedResources: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly contentUrl: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type fetchIssueAttachmentsSmartlinkDataQuery = {
  response: fetchIssueAttachmentsSmartlinkDataQuery$data;
  variables: fetchIssueAttachmentsSmartlinkDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v4 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "filters",
        "value": [
          {
            "integration": "CONFLUENCE"
          },
          {
            "integration": "LOOM"
          }
        ]
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "contentUrl"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "fetchIssueAttachmentsSmartlinkDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraResourcesResult",
                "kind": "LinkedField",
                "name": "getUnhydratedConsolidatedResources",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraResourceNode",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraResource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "fetchIssueAttachmentsSmartlinkDataQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraResourcesResult",
                "kind": "LinkedField",
                "name": "getUnhydratedConsolidatedResources",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraResourceNode",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraResource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4b5ea67d03d9e3f58ea9eb74be6abf19d7c9c183f8d844434f6956de6610b0bb",
    "metadata": {},
    "name": "fetchIssueAttachmentsSmartlinkDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f9aba400c96b0eba49d69dd457aed6d1";

export default node;
